// @ts-check
import React, { useCallback } from 'react';
import api from 'utils/api';

/** @typedef {{
  faxId: string;
  label?: string;
}} FaxLinkProps */

export const FaxLink = props => {
  const { faxId, label = 'View Document' } = props;

  const openDocument = useCallback(() => {
    return api.get(`/agent_portal/api/faxes/${faxId}/document_url`).then(resp => {
      if (resp.data.url) {
        window.open(resp.data.url);
      }
    });
  }, [faxId]);

  return (
    <button type="button" className="link" onClick={openDocument}>
      {label}
    </button>
  );
};
